import React, { useEffect, useState } from "react";
import ReactStars from "react-rating-stars-component";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";

const HOST = process.env.REACT_APP_HOST;
const API = process.env.REACT_APP_API;

const ReviewPopup = (props) => {
  const [name, setName] = useState();
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState();
  const [starsKey, setStarsKey] = useState(Math.random());
  const [showOtp, setShowOtp] = useState(false);
  const [phone_number, setPhoneNumber] = useState("");
  const [OTP, setOTP] = useState("");
  const [counter, setCounter] = useState(0);
  const [isResent,setIsResent] = useState(false)
  const [isEnableResent,setIsEnableResent] = useState(true)

  const { modalClose, uuid, getReview, setRatingLoading, isVisibleModal } =
    props;

  useEffect(() => {
    setName("");
    setReview("");
    setRating(0);
    setStarsKey(Math.random());
  }, [isVisibleModal]);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);
  const onSubmit = () => {
    // console.log("data", data);
    // toast.error("Wow so easy!");
    // setShow(true);
    // return;
    if (!name) {
      toast.error("Please enter your name.");
    } else if (!phone_number) {
      toast.error("Please enter your phone number.");
    } else if (
      phone_number &&
      (phone_number.length < 10 || phone_number.length > 10)
    ) {
      toast.error("Please enter valid phone number.");
    } else if (!review && !rating) {
      toast.error("Please share your review or rating!");
    } else if (!rating) {
      toast.error("Please share your rating!");
    } else if (!review) {
      toast.error("Please share your review!");
    } else {
      axios
        .post(`${HOST}${API}digitalcard/get-otp/`, {
          headers: {
            "Content-Type": "application/json",
          },
          phone_number: phone_number,
        })
        .then((response) => {
          if (response.status === 200) {
            setShowOtp(true);
            toast.success("Otp Sent Successfully!");
          } else {
            toast.error("error while saving review");
          }
          // this.setState({ ratingData: response.data.data });
        })
        .catch((error) => {
          // console.log(error);
          toast.error("error while saving review");
        });
    }
  };

  const saveReview = () => {
    if (!name) {
      toast.error("Please enter your name.");
    } else if (!phone_number) {
      toast.error("Please enter your phone number.");
    } else if (
      phone_number &&
      (phone_number.length < 10 || phone_number.length > 10)
    ) {
      toast.error("Please enter valid phone number.");
    } else if (!rating) {
      toast.error("Please share your rating!");
    } else if (!review) {
      toast.error("Please share your review!");
    } else if (!OTP) {
      toast.error("Please enter OTP!");
    } else {
      axios
        .post(`${HOST}${API}digitalcard/ratings-and-reviews/`, {
          headers: {
            "Content-Type": "application/json",
          },
          uuid: uuid,
          reviewer_name: name,
          star_rating: rating,
          review,
          phone_number: phone_number,
          otp: OTP,
        })
        .then((response) => {
          // console.log(
          //   JSON.stringify(response.data),
          //   "response.status",
          //   response.status
          // );
          if (response.status === 200) {
            setName("");
            setReview("");
            setRating("");
            modalClose();
            setRatingLoading(true);
            setShowOtp(false);
            setPhoneNumber("");
            setOTP("");
            getReview(props.uuid);
          } else {
            toast.error("error while saving review");
          }
          // this.setState({ ratingData: response.data.data });
        })
        .catch((error) => {
          // console.log(error.response);
          if (error.response.data && error.response.data.message) {
            toast.error(error.response.data.message.toString());
          } else {
            toast.error("error while saving review");
          }
        });
    }
  };
  const { t } = props;

  return (
    <div id="myModal" className="modal">
      <ToastContainer theme="colored" autoClose={1500} />
      <div className="modal-content">
        <div className="modal-header">
          <h3>{t("WRITE A REVIEWS")}</h3>
        </div>
        <div className="modal-body">
          <div className="modal-rating">
            <div className="stars">
              <ReactStars
                size={45}
                value={rating ? rating : 0}
                edit={true}
                isHalf={true}
                color="#ececec"
                activeColor="#FFF700"
                onChange={(value) => setRating(value)}
                key={starsKey}
              />
            </div>
          </div>
          <div className="form-group">
            <input
              type="text"
              name="full name"
              id="name"
              className="form-control"
              placeholder={t("Full Name")}
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </div>
          <div className="form-group">
            <input
              type="number"
              name="Enter phone number"
              id="phone_number"
              className="form-control"
              placeholder={t("Enter phone number")}
              onChange={(e) => setPhoneNumber(e.target.value)}
              value={phone_number}
              maxLength={"10"}
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
              }}
              // onInput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
          </div>
          <div className="form-group">
            <textarea
              id="comment"
              className="form-control"
              placeholder={t("Write Comment")}
              onChange={(e) => setReview(e.target.value)}
              value={review}
            />
          </div>

          {showOtp ? (
            <div className="form-group">
              <input
                type="number"
                name="Enter OTP"
                id="otp"
                className="form-control"
                placeholder={t("Enter OTP")}
                onChange={(e) => setOTP(e.target.value)}
                value={OTP}
                maxLength={"4"}
                onInput={(e) => {
                  e.target.value = e.target.value.slice(0, 4);
                }}
              />
              <h3
                style={{
                  color: "#D75928",
                  textDecoration: "underline",
                  textAlign: "center",
                  cursor: counter === 0 || isEnableResent? "pointer" : "",
                }}
                onClick={() => {
                  if (counter === 0 || isEnableResent) {
                    onSubmit();
                    setCounter(59)
                    setIsResent(true)
                    setIsEnableResent(false)
                  }
                }}
              >
                {t("Resend OTP")}
              </h3>
              {
                isResent ?
              <h3
                style={{
                  // color: "#D75928",
                  // textDecoration: "underline",
                  textAlign: "center",
                  // cursor: "pointer",
                }}
                onClick={() => {
                  onSubmit()
                }}
              >
                Resend OTP in <span>00:{counter}</span>
              </h3>:null
              }
            </div>
          ) : null}
        </div>
        <div className="modal-footer">
          <button
            onClick={() => {
              toast.dismiss()
              setName("");
              setReview("");
              setRating("");
              modalClose();
              // setRatingLoading(true);
              setShowOtp(false);
              setPhoneNumber("");
              setOTP("");
              setCounter(59)
              setIsResent(false)
              setIsEnableResent(false)

            }}
            className="btn btn-secondary"
          >
            {t("Cancel")}
          </button>
          <button
            className="btn"
            onClick={() => {
              if (showOtp) {
                saveReview();
              } else {
                onSubmit();
              }
            }}
          >
            {t("Submit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(ReviewPopup)